import { Card, CardBody, Flex, Text } from '@chakra-ui/react'
import { getBonusMetrics } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { numberFormatter } from 'lib'
import { useEffect, useState } from 'react'

export const BonusTiles = (props) => {
  const { createToast } = useAppContext()
  const [bonusMetrics, setBonusMetrics] = useState({ bonusYtd: 0, bonusWeek: 0 })

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getBonusMetrics()
        setBonusMetrics(response)
      } catch (err) {
        createToast('error', 'Error', 'Failed to load bonus metrics.')
      }
    }
    load()
  }, [])

  return (
    <Flex
      flexWrap="wrap"
      gap={4}
      {...props}
    >
      <Card
        textAlign="center"
        h="100px"
        width="250px"
      >
        <CardBody display="flex" flexDirection="column" justifyContent="space-between">
          <Text>Bonus (YTD)</Text>
          <Text fontWeight="bold" fontSize="lg">{`$ ${numberFormatter(bonusMetrics.bonusYtd)}`}</Text>
        </CardBody>
      </Card>
      <Card
        textAlign="center"
        h="100px"
        width="250px"
      >
        <CardBody display="flex" flexDirection="column" justifyContent="space-between">
          <Text>Bonus (This Week)</Text>
          <Text fontWeight="bold" fontSize="lg">{`$ ${numberFormatter(bonusMetrics.bonusWeek)}`}</Text>
        </CardBody>
      </Card>
    </Flex>
  )
}
